import TrocaVendaSevice from '@/services/TrocaVendaService'
import store from '@/store'
import VendaService from '@/services/VendaService'
import Helper from '@/helper'

export const actions = {
    cadastrarTrocaVenda: ({ commit, dispatch }) => {
        commit('setTrocaVenda', {})
        dispatch('setModalTrocaVenda', true)
    },
    salvarTrocaVenda: ({ commit, dispatch }, data) => {
        commit('setOverlay', true)
        TrocaVendaSevice.salvar(data)
            .then(res => {
                commit('setVenda', res.data)
                commit('snackbarSuccess', 'Troca efetuada com sucesso.')
                dispatch("setModalVisualizarVenda", true);
                commit('setOverlay', false)
                commit('setProdutosTroca', [])
            })
            .catch(e => {
                commit('setOverlay', false)
                commit('snackbarError', 'Erro ao efetuar a troca.')
            })
    },
    setModalTrocaVenda: ({ commit }, status) => {
        commit('setModalTrocaVenda', false)
        setTimeout(() => {
            commit('setModalTrocaVenda', status)
        }, 100)
    },
    removeProdutoTroca: ({ commit, dispatch }, data) => {
        commit('removeProdutoTroca', data)
        store.getters.getVenda.desconto_percentual = 0
        store.getters.getVenda.desconto -= data.preco_venda_devolucao
        dispatch('aplicaDescontoVenda')
    },
    async consultarTrocaVenda({ commit, dispatch }, vendaId) {
        commit('setTrocaVenda', {})
        commit('setProdutosTrocaVenda', [])
        commit('setOverlay', true)
        await VendaService.editar(vendaId)
            .then(res => {
                if (res.data.id) {
                    let venda = res.data
                    res.data.itens.map(o => {
                        commit('addProdutoTrocaVenda', {
                            id: o.id,
                            produto_id: o.produto_id,
                            descricao: o.produto.descricao,
                            preco_venda: Helper.formatReal(parseFloat(o.preco_venda)),
                            quantidade: Helper.formatReal(parseFloat(o.quantidade)),
                            desconto: Helper.formatReal(parseFloat(o.desconto)),
                            total_venda: Helper.formatReal(parseFloat(o.total_venda)),
                        })
                    })

                    let dadosFormatados = {
                        subtotal: Helper.formatReal(parseFloat(res.data.subtotal)),
                        total: Helper.formatReal(parseFloat(res.data.subtotal)),
                        valor_pago: Helper.formatReal(parseFloat(res.data.valor_pago)),
                        troco: Helper.formatReal(parseFloat(res.data.troco)),
                    }

                    commit('setTrocaVenda', { ...venda, ...dadosFormatados })

                } else {
                    commit('snackbarError', 'Venda não encontrada.')
                }
                commit('setOverlay', false)

            })
            .catch(e => {
                console.log(e)
                commit('setOverlay', false)
                commit('snackbarError', 'Erro ao consultar venda.')
            })
    },
    setTrocaVenda: ({ commit, dispatch}) => {
        let saldoTroca = 0
        let produtosTroca = store.getters.getProdutosTrocaVenda.filter(item => item.devolver && Helper.cleanFormatReal(item.quantidade_devolvida) > 0)
        
        if (produtosTroca.length <= 0) {
            commit('snackbarError', 'Marque os produtos a serem devolvidos.')
            return
        }

        produtosTroca.map(item => {
            let produto = {
                id: item.id,
                produto_id: item.produto_id,
                quantidade_devolvida: item.quantidade_devolvida,
                descricao: item.descricao,
                preco_venda: item.preco_venda,
                preco_custo: item.preco_custo,
                preco_venda_devolucao: Helper.cleanFormatReal(item.preco_venda) * Helper.cleanFormatReal(item.quantidade_devolvida),
                preco_custo_devolucao: item.preco_custo ? Helper.cleanFormatReal(item.preco_custo) : 0 * Helper.cleanFormatReal(item.quantidade_devolvida)
            }

            saldoTroca += produto.preco_venda_devolucao
            commit('addProdutoTroca', produto)

        })

        store.getters.getVenda.saldo_troca = Helper.formatReal(saldoTroca)
        commit('setTroca', {
            venda_id: store.getters.getTrocaVenda.id,
        })

        dispatch('setModalTrocaVenda', false)
        dispatch('setModalListarVenda', false)
        // dispatch('aplicaDescontoVenda')
    },

}

export default {}